import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {TextField} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {addBRPortfolioEntity, addSubportfolio} from "../../../actions";
import BBExternalLink from "../accents/BBExternalLink";
import {isFunctionComponent} from "../../../util/bbHelpers";


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const {closerCallback} = props;
    // console.log("Displaying add organization to portfolio form. Customer ID is", targetCustomerId)

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustAddSubportfolio} = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {customerInView} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();

    const [subportfolioName, setSubportfolioName] = useState(null);
    const [description, setDescription] = useState(null);


    const clearForm = () => {
        setSubportfolioName("");
        setDescription("");
        document.getElementById('BRPortfolioAddNewSubportfolioForm').reset();
    }


  useEffect(() => {
    if(didJustAddSubportfolio) {
        clearForm();
    }
  }, [dispatch, didJustAddSubportfolio]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {

        dispatch(addSubportfolio(
            customerInView,
            subportfolioName,
            description,
        ));

        //close the dialog
        if(closerCallback && typeof closerCallback === 'function'){
            closerCallback();
        } else {
            console.warn("failed to close the remove entity from portfolio group dialog", "closerCallback", closerCallback, "isFunctionComponent(closerCallback)", isFunctionComponent(closerCallback), "typeof", typeof closerCallback)
        }


    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">

            <form id={"BRPortfolioAddNewSubportfolioForm"} className={classes.root}>

                {/*<h3>Organization Information</h3>*/}
                <TextField
                    label={<IntlMessages id="appModule.BRPortfolioAddNewSubportfolioForm.name"/>}
                    // fullWidth
                    id="subportfolio_name"
                    name="subportfolioName"
                    required
                    error={!!errors.subportfolioName}
                    onChange={(event) => setSubportfolioName(event.target.value)}
                    defaultValue={subportfolioName}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.subportfolioName
                        ? errors.subportfolioName.message
                        : <>This will be the title of your new portfolio group.</>
                    }
                />
                <br/>
                <TextField
                    label={<IntlMessages id="appModule.BRPortfolioAddNewSubportfolioForm.description"/>}
                    // fullWidth
                    id="description"
                    name="description"
                    // required
                    error={!!errors.description}
                    onChange={(event) => setDescription(event.target.value)}
                    defaultValue={description}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    // inputRef={register({
                    //     required: "This field is required." ,
                    // })}
                    helperText={errors.description
                        ? errors.description?.message
                        : <>This description will guide your team in how this group should be used within your business process.</>
                    }
                />

                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.subportfolioName || !!errors.description}
                                variant="contained" color="primary"
                                type="submit">
                            <IntlMessages id="form.submit"/>
                        </Button>
                    </div>

            </form>

        </div>
    );

}

export default Form